// extracted by mini-css-extract-plugin
module.exports = {"textFaded":"Addresses_textFaded__2YTUL","resultRow":"Addresses_resultRow__10725","yesLabel":"Addresses_yesLabel__3YLMo","yesLabelIcon":"Addresses_yesLabelIcon__13j90"};